import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';

const MobileDropdownV1 = ({value, placeholder, cy, handleChange, label, options, invalidInput}) => {
	const [expanded, setExpanded] = useState(false);

	const [userHasChosen, setUserHasChosen] = useState(value !== '');

	const handleDropdownExpand = () => {
		setExpanded(!expanded);
	};

	const handleOnChange = event => {
		setExpanded(!expanded);
		setUserHasChosen(true);
		handleChange(event.target.value);
	};

	const handleOnBlur = () => {
		if (expanded) {
			setExpanded(false);
		}
	};

	const selectRender = () => {
		return (
			<select
				onFocus={() => handleDropdownExpand()}
				onBlur={() => handleOnBlur()}
				defaultValue={value !== '' ? value : placeholder}
				className={'mobile-dropdown ' + (expanded ? 'expanded ' : '') + (userHasChosen ? 'made-selection' : '')}
				data-cy={cy + '-select'}
				onChange={event => {
					handleOnChange(event);
				}}
			>
				<option disabled hidden value={placeholder}>
					{placeholder}
				</option>
				{options.map((option, index) => {
					return (
						<option key={index} value={option.value} data-cy={cy + '-option-' + index}>
							{option.label}
						</option>
					);
				})}
			</select>
		);
	};

	return (
		<div data-cy={cy} className={'mobile-select-wrapper ' + (invalidInput ? 'invalid' : '')}>
			<label>{label}</label>
			{selectRender()}
		</div>
	);
};

MobileDropdownV1.propTypes = {
	value: PropTypes.string,
	placeholder: PropTypes.string,
	cy: PropTypes.string,
	handleChange: PropTypes.func,
	label: PropTypes.string,
	options: PropTypes.array,
	invalidInput: PropTypes.bool,
};

export default injectIntl(MobileDropdownV1);
